import { Button, Image, Input, makeStyles, mergeClasses, Tooltip } from '@fluentui/react-components';
import { useCheckPopUpBlockerFunction } from '../../utils/CheckPopUpBlockerFunction';
import InputBlock from './InputBlock';
import InputLabel from './InputLabel';
import InputGroup from './InputGroup';
import React, { useCallback } from 'react';

const useStyles = makeStyles({
  input: {
    width: '100%',
    paddingLeft: 0,
  },
  inputGroup: {
    marginTop: '-10px', //Fluent-UI inputs don't appear quite in line with P4 ones like BlurTextField, so shunt it up a bit.
  },
  button: {
    padding: 0,
  },
  inputContainer: {
    minHeight: '21px',
    paddingTop: '5px',
  },
});
export const What3WordsInput = ({
  value,
  onChange,
  label,
  labelCols,
  inputCols,
  readOnly,
  'data-testid': dataTestId,
}: {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  labelCols?: number;
  inputCols?: number;
  readOnly?: boolean;
  'data-testid': string;
}) => {
  const checkPopUpBlockerFunction = useCheckPopUpBlockerFunction();

  const styles = useStyles();

  const regex =
    /^\/{0,}(?:[^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+|[^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+([\u0020\u00A0][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+){1,3}[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+([\u0020\u00A0][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+){1,3}[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+([\u0020\u00A0][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]+){1,3})$/;
  const isValid = regex.test(value);
  const tooltip = isValid ? 'View location on what3words.com' : 'Invalid location, cannot be viewed';

  const rootOverride = useCallback(
    (Root, props) => <Root {...props} className={mergeClasses(props.className, styles.inputContainer)} />,
    [styles.inputContainer]
  );

  return (
    <InputBlock flexBox={true} data-testid={dataTestId}>
      <InputLabel
        hint={
          "Type the three words, separated by '.', that are associated with the specific location you want to pinpoint. Do not use spaces in your text."
        }
        label={label}
        cols={labelCols ?? 1 / 4}
        styles={{ label: { verticalAlign: 'middle' } }}
      />
      <InputGroup flexBox={true} cols={inputCols ?? 3 / 4} withLabel={!!label} className={styles.inputGroup}>
        <Input
          className={styles.input}
          root={{
            children: rootOverride,
          }}
          appearance={'underline'}
          contentAfter={
            <Tooltip content={tooltip} relationship="label">
              <Button
                className={styles.button}
                icon={<Image src="/images/w3w_Symbol_RGB_Red.svg" alt="what3words" width={55} fit={'cover'} />}
                appearance={'subtle'}
                onClick={() => {
                  checkPopUpBlockerFunction(`https://what3words.com/${value}`, '_blank');
                }}
                disabled={!isValid}
              />
            </Tooltip>
          }
          value={value ?? ''}
          onChange={(ev, data) => {
            onChange(data.value);
          }}
          readOnly={readOnly}
        />
      </InputGroup>
    </InputBlock>
  );
};
